import { useState } from 'react'
import { useAuth } from '../auth'

export default function Login() {
  const auth = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      await auth.login(username, password)
    } catch {
      setError('Invalid credentials')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="flex h-screen items-start justify-center bg-[color:var(--me-bg)] p-4 pt-[22vh]">
      <form onSubmit={handleSubmit} className="me-card me-fade-in w-full max-w-sm p-7" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
        <div className="mb-5 flex flex-col items-center gap-1">
          <div className="mb-1 flex items-center gap-2">
            <span className="inline-block h-3.5 w-3.5 rounded-sm bg-[color:var(--me-fg)]" />
            <div className="text-[15px] font-semibold tracking-tight me-text">Matter Engine</div>
          </div>
          <div className="me-text-mute text-[12px]">Sign in to continue</div>
        </div>
        <label className="mb-1.5 block text-[11px] uppercase tracking-wider me-text-mute">Username</label>
        <input
          autoFocus
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="me-input mb-3"
        />
        <label className="mb-1.5 block text-[11px] uppercase tracking-wider me-text-mute">Password</label>
        <input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="me-input mb-4"
        />
        {error && <div className="mb-3 text-[12px] text-[color:var(--me-urgent)]">{error}</div>}
        <button type="submit" disabled={submitting} className="me-btn me-btn-primary w-full justify-center py-2">
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
